import { css } from "styled-components"

import media from "./media"

const shadows = {
  darkModeButtonShadow: css`
    box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.3);
    ${media.desktop} {
      box-shadow: 0vw 0.904vw 1.807vw rgba(0, 0, 0, 0.3);
    }
    ${media.tablet} {
      box-shadow: 0vw 1.465vw 2.93vw rgba(0, 0, 0, 0.3);
    }
    ${media.mobile} {
      box-shadow: 0vw 4vw 8vw rgba(0, 0, 0, 0.3);
    }
  `,
  darkModeSurfaceShadow: css`
    box-shadow: 20px 40px 80px rgba(1, 3, 13, 0.2);
    ${media.desktop} {
      box-shadow: 1.205vw 2.41vw 4.819vw rgba(1, 3, 13, 0.2);
    }
    ${media.tablet} {
      box-shadow: 1.953vw 3.906vw 7.813vw rgba(1, 3, 13, 0.2);
    }
    ${media.mobile} {
      box-shadow: 5.333vw 10.667vw 21.333vw rgba(1, 3, 13, 0.2);
    }
  `,
  lightModeButtonShadow: css`
    box-shadow: 0px 15px 30px rgba(22, 50, 145, 0.12);
    ${media.desktop} {
      box-shadow: 0vw 0.904vw 1.807vw rgba(22, 50, 145, 0.12);
    }
    ${media.tablet} {
      box-shadow: 0vw 1.465vw 2.93vw rgba(22, 50, 145, 0.12);
    }
    ${media.mobile} {
      box-shadow: 0vw 4vw 8vw rgba(22, 50, 145, 0.12);
    }
  `,
  lightModeSurfaceShadow: css`
    box-shadow: 20px 40px 40px rgba(11, 35, 115, 0.075);
    ${media.desktop} {
      box-shadow: 1.205vw 2.41vw 2.41vw rgba(11, 35, 115, 0.075);
    }
    ${media.tablet} {
      box-shadow: 1.953vw 3.906vw 3.906vw rgba(11, 35, 115, 0.075);
    }
    ${media.mobile} {
      box-shadow: 5.333vw 10.667vw 10.667vw rgba(11, 35, 115, 0.075);
    }
  `,
  cardMockupShadow: css`
    box-shadow: 0px 17.1953px 25.2872px rgba(0, 0, 0, 0.11);
    ${media.desktop} {
      box-shadow: 0vw 1.036vw 1.523vw rgba(0, 0, 0, 0.11);
    }
    ${media.tablet} {
      box-shadow: 0vw 1.679vw 2.469vw rgba(0, 0, 0, 0.11);
    }
    ${media.mobile} {
      box-shadow: 0vw 4.585vw 6.743vw rgba(0, 0, 0, 0.11);
    }
  `,
}

export default shadows
